<template>
  <div>
    <el-row class="text-center system-stepcon">
      <el-col :span="14" :offset="5">
        <el-form :rules="rules" :model="system_stepOneForm" ref="system_stepOneForm" label-width="150px">
          <el-form-item label="策略名称" prop="acdName" size="medium" style="padding-right:10%;">
            <el-input size="medium" maxlength="16" @input="forceInput" v-model="system_stepOneForm.acdName"></el-input>
          </el-form-item>
          <el-form-item class="text-left" prop="channelIds" label="所属渠道" size="medium">
            <el-checkbox-group @input="forceInput" v-model="system_stepOneForm.channelIds">
              <el-checkbox v-for="platform in platforms" :label="platform.tag" :key="platform.id">{{platform.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="system-stepcon-time" style="margin-top:20px" label="策略时间" size="medium">
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked1"  @change="changeCk(1)" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周一</p>
                <!-- 日期时间框 -->
                <el-time-picker
                  is-range
                  v-model="system_stepOneForm.startAndEndTime1"
                  format ="HH:mm"
                  value-format="HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
                </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked2" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周二</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm" is-range v-model="system_stepOneForm.startAndEndTime2" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked3" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周三</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm"  is-range v-model="system_stepOneForm.startAndEndTime3" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked4" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周四</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm"  is-range v-model="system_stepOneForm.startAndEndTime4" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked5" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周五</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm"  is-range v-model="system_stepOneForm.startAndEndTime5" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked6" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周六</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm"  is-range v-model="system_stepOneForm.startAndEndTime6" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
              <el-checkbox class="text-left" v-model="system_stepOneForm.checked7" style="width:430px;margin-right:0px;">
                <p class="text-left system-stepcon-checktxt">周日</p>
                <!-- 日期时间框 -->
                  <el-time-picker size="medium" format='HH:mm' value-format="HH:mm"  is-range v-model="system_stepOneForm.startAndEndTime7" range-separator="至"
                                  start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                  </el-time-picker>
              </el-checkbox>
          </el-form-item>
          <el-form-item class="text-left" label="法定假日除外">
            <el-switch v-model="system_stepOneForm.excludeHoliday" @input="forceInput" :width="50" :active-value=1 :inactive-value=0  active-color="#337eff" inactive-color="#dcdfe6"></el-switch>
          </el-form-item>
          <el-form-item class="text-left" label="非策略时间进线话术">
            <el-input type="textarea" @input="forceInput" placeholder="请输入引导话术内容" maxlength="100" v-model="system_stepOneForm.extimeServiceWords"></el-input>
          </el-form-item>
          <el-form-item class="text-left" label="非策略时间进线策略">
            <el-select v-model="system_stepOneForm.extimeServiceType" @input="forceInput" placeholder="请选择非策略时间进线策略">
              <el-option label="机器人服务" :value="0"></el-option>
              <el-option label="用户留言" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="text-left" label="开启黑名单">
            <el-switch v-model="system_stepOneForm.enableBlacklist" @input="forceInput" :width="50" :active-value=1 :inactive-value=0  active-color="#337eff" inactive-color="#dcdfe6"></el-switch>
          </el-form-item>
          <el-form-item class="text-left" label="开启熟客优先">
            <el-switch v-model="system_stepOneForm.enableRegularCustomerFirst" @input="forceInput" :width="50" :active-value=1 :inactive-value=0  active-color="#337eff" inactive-color="#dcdfe6"></el-switch>
          </el-form-item>
          <el-form-item size="medium" label="同条会话判定时间" class="text-left system-stepcon-itemlist">
            <el-input-number style="width:100px;" class="system-mr10" v-model="system_stepOneForm.mergeSessionInterval" controls-position="right" @input="forceInput" :min="0" :max="120"></el-input-number>
            <span>分钟</span>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="text-center system-stepbtn">
      <el-button @click="cancel" class="customer-mr20" size="medium">取 消</el-button>
      <el-button @click="nextStep" size="medium" type="primary">下一步</el-button>
    </el-row>
  </div>
</template>
<script>
import { getPlatforms, getAcdById } from '@/api/user'
import { mapActions } from 'vuex'
export default {
  name: 'stepOne',
  data() {
    return {
      cacheAcd: {},
      platforms: [],
      system_stepOneForm_blank: {
        acdName: '',
        channelIds: [],
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
        checked6: false,
        checked7: false,
        startAndEndTime1: ['', ''],
        startAndEndTime2: ['', ''],
        startAndEndTime3: ['', ''],
        startAndEndTime4: ['', ''],
        startAndEndTime5: ['', ''],
        startAndEndTime6: ['', ''],
        startAndEndTime7: ['', ''],
        excludeHoliday: 0, // 是否排除法定假日，0：false，1：true
        enableBlacklist: 0, // 是否开启黑名单，0：FALSE，1：TRUE
        excludeHoenableRegularCustomerFirstliday: 0, // 是否开启熟客优先，0：FALSE，1：TRUE
        extimeServiceType: 1, // 非策略时间进线策略类型，0：机器人，1：用户留言
        mergeSessionInterval: 0, // 同条会话判定时间
        extimeServiceWords: '您好，目前正处于坐席非工作时间，请您在工作时间再与我们联系。'// 非策略时间进线话术，
      },
      system_stepOneForm: {
        acdName: '',
        channelIds: [],
        checked1: true,
        checked2: true,
        checked3: true,
        checked4: true,
        checked5: true,
        checked6: true,
        checked7: true,
        startAndEndTime1: ['00:00', '23:59'],
        startAndEndTime2: ['00:00', '23:59'],
        startAndEndTime3: ['00:00', '23:59'],
        startAndEndTime4: ['00:00', '23:59'],
        startAndEndTime5: ['00:00', '23:59'],
        startAndEndTime6: ['00:00', '23:59'],
        startAndEndTime7: ['00:00', '23:59'],
        excludeHoliday: 0, // 是否排除法定假日，0：false，1：true
        enableBlacklist: 0, // 是否开启黑名单，0：FALSE，1：TRUE
        excludeHoenableRegularCustomerFirstliday: 0, // 是否开启熟客优先，0：FALSE，1：TRUE
        extimeServiceType: 1, // 非策略时间进线策略类型，0：机器人，1：用户留言
        mergeSessionInterval: 0, // 同条会话判定时间
        extimeServiceWords: '您好，目前正处于坐席非工作时间，请您在工作时间再与我们联系。'// 非策略时间进线话术，
      },
      rules: {
        acdName: [
          { required: true, message: '请输入策略名称', trigger: 'blur' },
          { min: 2, max: 16, message: '字符长度2-16个字符', trigger: 'blur' }
          // { validator: validateRemoteAcdName, trigger: 'blur' }
        ],
        channelIds: [
          { type: 'array', required: true, message: '请至少选择一个渠道', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    blankAcdTime() {
      return this.$store.state.user.blankAcdTime
    },
    curAcdId() { // 从策略列表跳转到详情时的缓存
      return this.$store.state.user.curAcdId
    },
    blankAcd() { // acd空对象
      return this.$store.state.user.blankAcd
    },
    vuexCacheAcd() { // acd缓存
      return this.$store.state.user.acdCache
    }
  },
  mounted() {
    this._getPlatforms()
    this._listSkillGroup()
    /* if (this.curAcdId) {
      this._getAcdById(this.curAcdId)
    } else  */
    if (Object.keys(this.vuexCacheAcd).length !== 0) {
      Object.assign(this.cacheAcd, this.vuexCacheAcd)
      Object.assign(this.system_stepOneForm, this.system_stepOneForm_blank)
      this.loadAcdTime(this.cacheAcd)
    } else {
      this.cacheAcd = JSON.parse(JSON.stringify(this.blankAcd))
    }
  },
  methods: {
    ...mapActions('user', ['_listSkillGroup']),
    forceInput() {
      this.$forceUpdate()// 强制刷新视图，每一个无法输入的input框都需要使用该方法
    },
    changeCk(index) {

    },
    _getPlatforms() {
      getPlatforms().then(
        res => {
          if (res.code === 2000) {
            this.platforms = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    _getAcdById(acdId) {
      getAcdById({ acdId }).then(
        res => {
          if (res.code === 2000) {
            this.cacheAcd = res.data
            // 加载策略时间
            this.loadAcdTime(res.data)
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    loadAcdTime(paramAcd) {
      const acdTimes = paramAcd.acdTimes
      if (acdTimes && acdTimes.length > 0) {
        // i从0开始，weekday为1-7
        acdTimes.forEach((v, i) => {
          if (v.startTime && v.endTime) {
            if (v.weekday === 1) {
              this.system_stepOneForm.checked7 = true
              this.system_stepOneForm.startAndEndTime7 = [v.startTime, v.endTime]
            } else {
              this.system_stepOneForm['checked' + (v.weekday - 1)] = true
              this.system_stepOneForm['startAndEndTime' + (v.weekday - 1)] = [v.startTime, v.endTime]
            }
          }
        })
      }
      this.system_stepOneForm.acdName = paramAcd.acdName
      this.system_stepOneForm.channelIds = paramAcd.channelIds
      this.system_stepOneForm.excludeHoliday = paramAcd.excludeHoliday
      this.system_stepOneForm.enableBlacklist = paramAcd.enableBlacklist
      this.system_stepOneForm.mergeSessionInterval = paramAcd.mergeSessionInterval
      this.system_stepOneForm.enableRegularCustomerFirst = paramAcd.enableRegularCustomerFirst
      this.system_stepOneForm.extimeServiceType = paramAcd.extimeServiceType
      this.system_stepOneForm.extimeServiceWords = paramAcd.extimeServiceWords
    },
    nextStep() {
      this.$refs.system_stepOneForm.validate(valid => {
        // 表单校验通过,提交到后端
        if (valid) {
          this._nextStep()
        } else {
          // 表单校验不通过,驳回重新填写
          return false
        }
      })
    },
    _nextStep() {
      this.cacheAcd.acdTimes = []
      for (let i = 1; i < 8; i++) {
        if (!this.system_stepOneForm['checked' + i] || this.system_stepOneForm['startAndEndTime' + i].length === 0) {
          continue
        }
        const time = {}
        Object.assign(time, this.blankAcdTime)// 拷贝属性
        let flag = false
        if (i === 7) {
          if (this.system_stepOneForm['startAndEndTime' + i]) {
            time.weekday = 1
            flag = true
          }
        } else {
          if (this.system_stepOneForm['startAndEndTime' + i]) {
            time.weekday = i + 1
            flag = true
          }
        }
        time.startTime = this.system_stepOneForm['startAndEndTime' + i][0]
        time.endTime = this.system_stepOneForm['startAndEndTime' + i][1]
        if (flag) {
          this.cacheAcd.acdTimes.push(time)
        }
      }
      this.cacheAcd.acdName = this.system_stepOneForm.acdName
      this.cacheAcd.channelIds = this.system_stepOneForm.channelIds
      this.cacheAcd.excludeHoliday = this.system_stepOneForm.excludeHoliday
      this.cacheAcd.enableBlacklist = this.system_stepOneForm.enableBlacklist
      this.cacheAcd.enableRegularCustomerFirst = this.system_stepOneForm.enableRegularCustomerFirst
      this.cacheAcd.mergeSessionInterval = this.system_stepOneForm.mergeSessionInterval
      this.cacheAcd.extimeServiceType = this.system_stepOneForm.extimeServiceType
      this.cacheAcd.extimeServiceWords = this.system_stepOneForm.extimeServiceWords
      // 保存数据进vuex
      this.$store.commit('user/setAcdCache', { acd: this.cacheAcd })
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 2 })
      this.$store.commit('user/setAcdTimeForm', { acdTimeForm: this.system_stepOneForm })
    },
    cancel() {
      this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 1 })
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
    }
  }
}
</script>
